import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { WatermarkFormContext } from 'context';
import type { Watermark as WatermarkConfig } from 'types';

import { WatermarkForm, WatermarkHeader } from './components';

export default function WatermarkSetting() {
  const data = useLoaderData() as WatermarkConfig | undefined;

  const { top, bottom, right, left } = data ?? {};

  return (
    <React.Fragment>
      <Helmet>
        <title>تنظیمات نهان‌نگاری | کاشی لند</title>
      </Helmet>
      <WatermarkHeader />
      <WatermarkFormContext
        position={{
          block: [Number.isFinite(top) ? 'top' : 'bottom', top ?? bottom],
          inline: [Number.isFinite(right) ? 'right' : 'left', right ?? left],
        }}
        ownerType='Config'
        {...data}
      >
        <WatermarkForm />
      </WatermarkFormContext>
    </React.Fragment>
  );
}
